var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SubMenuHeader',{attrs:{"title":_vm.$t('itemsNeeded.pageTitle')},on:{"onGoBack":_vm.goBack,"showVideo":function($event){return _vm.$emit('showVideo')}}}),_c('div',{staticClass:"container--fluid"},[_c('AppItemList',{staticClass:"mt-7"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }